// @flow
import waitForAnalytics from './wait'

export default function reset() {
  waitForAnalytics(() => window.analytics.reset())
}
